import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormInven08  extends React.Component{
    constructor(props){
        super(props);
        this.state = {            
            fechaDesde: null,
            fechaHasta: null,
            tipoMovimiento: 'I' // (I): INGRESOS DE BODEGA - (E): EGRESOS DE BODEGA
        };
        
        this.limpiar = this.limpiar.bind(this);
        this.imprimirMovimientosBodegaPorTipo = this.imprimirMovimientosBodegaPorTipo.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }    

    componentDidMount(){        
        this.props.generar_LogAuditoriaIngresoForm('0208');
        let fechaProceso = getFechaProcesoPorModulo('02');        
        
        this.setState({ fechaHasta: moment(fechaProceso, "DD/MM/YYYY"),
                        fechaDesde: moment(fechaProceso, "DD/MM/YYYY") });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0208');
    }  

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('02');
        this.setState({ fechaHasta: moment(fechaProceso, "DD/MM/YYYY"),
                        fechaDesde: moment(fechaProceso, "DD/MM/YYYY"),
                        tipoMovimiento: 'I'
                    });
    }

    imprimirMovimientosBodegaPorTipo(){
        if(!validarFechaMomentEnFormatoString(formatearFechaMoment_a_String(this.state.fechaDesde))){
            alert('La fecha Desde es inválida.');
            return;
        }

        if(!validarFechaMomentEnFormatoString(formatearFechaMoment_a_String(this.state.fechaHasta))){
            alert('La fecha Hasta es inválida.');
            return;
        }

        if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){
            alert('La fecha Desde no puede ser mayor que la fecha Hasta.');
            return;
        }
        let parametrosRpt = "";
        if (this.state.tipoMovimiento === 'I'){
            parametrosRpt += "&rpt=44";
        }else{
            parametrosRpt += "&rpt=43";
        }
        
        parametrosRpt += "&param1=" + formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde);
        parametrosRpt += '&param2=' + formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);

        visualizarReporteEnPdf(parametrosRpt);
    }  

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Ingresos/Egresos de Bodega</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-5' margen_arriba='15'>
                            <LabelForm>Tipo Movimiento:</LabelForm>
                            <div>
                            <LabelForm className='radio-inline'>
                                <input type="radio" name="tipoMovimiento" value="I" checked={this.state.tipoMovimiento==="I"} onChange={this.handleInputChange}/>
                                Ingresos
                            </LabelForm>
                            <LabelForm className='radio-inline'>
                                <input type="radio" name="tipoMovimiento" value="E" checked={this.state.tipoMovimiento==="E"} onChange={this.handleInputChange}/>
                                Egresos
                            </LabelForm>
                            </div>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-1' margen_arriba='15'>
                            <LabelForm>Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-3' margen_arriba='15'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-1' margen_arriba='15'>
                            <LabelForm>Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-3' margen_arriba='15'>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.imprimirMovimientosBodegaPorTipo}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});
  
export default connect (null, mapDispatchToProps)(FormInven08);